import usePrice from '@commerce/product/use-price'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
interface Props {
  label: string
  value: string
  price: number
  currencyCode: string
}
const ProductOptionItem: FC<Props> = ({
  label,
  value,
  price,
  currencyCode,
}) => {
  const { t } = useTranslation('common')
  const { price: formattedPrice } = usePrice({
    amount: price,
    currencyCode,
    suffix: `(${t('excl-vat')})`,
  })
  return (
    <option label={`${label} (${formattedPrice})`} value={value}>
      {label}
    </option>
  )
}

export default ProductOptionItem
